module.exports = __webpack_public_path__ + "static/media/fast_bet_first.0c6e1bfc.mp3";